<template>
    <div class="integrations-panel">
        <div class="integration-cards">
            <div class="integration-card">
                <div class="integration-header">
                    <div class="integration-icon">
                        <i class="pi pi-check-square"></i>
                    </div>
                    <div class="integration-info">
                        <h4>ClickUp</h4>
                        <p>Enrich links to ClickUp tasks.</p>
                    </div>
                </div>
                <Badge
                    :severity="isClickUpSetup ? 'primary' : 'secondary'"
                    class="integration-status"
                >
                    {{ isClickUpSetup ? "Configured" : "Not Configured" }}
                </Badge>
                <Button
                    :label="isClickUpSetup ? 'Edit Configuration' : 'Configure'"
                    :icon="isClickUpSetup ? 'pi pi-pencil' : 'pi pi-plus'"
                    @click="openClickUpDialog"
                    :severity="isClickUpSetup ? 'secondary' : 'primary'"
                />
            </div>

            <!-- GitLab Integration Card -->

            <div class="integration-card">
                <div class="integration-header">
                    <div class="integration-icon gitlab-icon">
                        <GitLabLogo alt="GitLab" />
                    </div>
                    <div class="integration-info">
                        <h4>GitLab</h4>
                        <p>Enrich links to GitLab merge requests.</p>
                    </div>
                </div>
                <Badge
                    :severity="isGitLabSetup ? 'primary' : 'secondary'"
                    class="integration-status"
                >
                    {{ isGitLabSetup ? "Configured" : "Not Configured" }}
                </Badge>
                <Button
                    :label="isGitLabSetup ? 'Edit Configuration' : 'Configure'"
                    :icon="isGitLabSetup ? 'pi pi-pencil' : 'pi pi-plus'"
                    @click="openGitLabDialog"
                    :severity="isGitLabSetup ? 'secondary' : 'primary'"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import GitLabLogo from "@/assets/img/logos/gitlab.svg";
import { useClickUpSettingsDialog } from "@/composables/clickup-settings-dialog";
import { useGitLabSettingsDialog } from "@/composables/gitlab-settings-dialog";
import { IntegrationType, useIntegrationManager } from "@/stores/integration";
import Badge from "primevue/badge";
import Button from "primevue/button";

const { isSetup: isClickUpSetup } = useIntegrationManager(
    IntegrationType.CLICKUP
);
const { isSetup: isGitLabSetup } = useIntegrationManager(
    IntegrationType.GITLAB
);
const { open: openClickUpDialog } = useClickUpSettingsDialog();
const { open: openGitLabDialog } = useGitLabSettingsDialog();
</script>

<style scoped lang="scss">
.integrations-panel {
    h3 {
        margin-top: 0;
        margin-bottom: 0.5rem;
    }

    p {
        margin-bottom: 1.5rem;
        color: var(--text-color);
    }
}

.integration-cards {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.integration-card {
    display: flex;
    align-items: center;
    padding: 1.25rem;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e9ecef;
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    &.disabled {
        opacity: 0.7;
        pointer-events: none;
    }
}

.integration-header {
    display: flex;
    align-items: center;
    flex: 1;
}

.integration-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f7ff;
    border-radius: 8px;
    margin-right: 1rem;

    i {
        font-size: 1.5rem;
        color: var(--stekz-primary-color);
    }

    &.gitlab-icon {
        background: #fff;
    }
}

.integration-status {
    margin-right: 1.5rem;
}

.integration-info {
    flex: 1;

    h4 {
        margin: 0 0 0.25rem 0;
        font-size: 1.1rem;
    }

    p {
        margin: 0;
        font-size: 0.875rem;
        color: #6c757d;
    }
}
</style>
